import { render, staticRenderFns } from "./TeachingList.vue?vue&type=template&id=d804199c&scoped=true&"
import script from "./TeachingList.vue?vue&type=script&lang=js&"
export * from "./TeachingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d804199c",
  null
  
)

export default component.exports